import { marker as _ } from '@jsverse/transloco-keys-manager/marker';
import { NavigationWithoutChildren } from '@mds/ngx-layout';

export const untranslatedNavigationItems: NavigationWithoutChildren[] = [
  {
    label: _('i18n.Shift.List.Title'),
    link: 'shifts',
    icon: 'punch_clock',
  },
  {
    label: _('i18n.Deployment.List.Title'),
    link: 'deployments',
    icon: 'assignment',
  },
  {
    label: _('i18n.Vehicle.List.Title'),
    link: 'vehicles',
    icon: 'local_shipping',
  },
  {
    label: _('i18n.VehiclePlanning.List.Title'),
    link: 'vehicleplanning',
    icon: 'departure_board',
  },
  {
    label: _('i18n.Driver.List.Title'),
    link: 'drivers',
    icon: 'person',
  },
  {
    label: _('i18n.DriverPlanning.List.Title'),
    link: 'driverplanning',
    icon: 'co_present',
  },
];
